import { asyncActionType } from "utils/constants";

export const CLEAR_LOCATIONS = "CLEAR_LOCATIONS";
export const GET_LOCATIONS = asyncActionType("GET_LOCATIONS");
export const GET_LOCATION = asyncActionType("GET_LOCATION");
